import { useTranslation } from 'react-i18next';
import { CheckCircle } from 'lucide-react';
import type { OnboardingData } from './types.js';

interface Props {
  data: OnboardingData;
  onDone: () => void;
}

export default function StepDone({ data, onDone }: Props) {
  const { t } = useTranslation('onboarding');

  const inviteCount = data.invites.filter((i) => i.email.trim()).length;

  return (
    <div className="page-enter" style={{ textAlign: 'center', padding: 'var(--space-10) 0' }}>
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 'var(--radius-full)',
          background: 'var(--color-success-light)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto var(--space-6)',
        }}
      >
        <CheckCircle size={32} color="var(--color-success)" />
      </div>

      <h2
        style={{
          fontSize: 'var(--text-2xl)',
          fontWeight: 'var(--weight-light)',
          color: 'var(--color-text)',
          marginBottom: 'var(--space-2)',
          letterSpacing: 'var(--tracking-tight)',
        }}
      >
        {t('done.title')}
      </h2>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)', marginBottom: 'var(--space-8)' }}>
        {t('done.subtitle')}
      </p>

      <div
        style={{
          background: 'var(--color-bg-subtle)',
          border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-5)',
          textAlign: 'left',
          marginBottom: 'var(--space-8)',
        }}
      >
        {[
          t('done.workspace_item', { name: data.companyName }),
          t('done.stages_item', { count: data.stages.length }),
          t('done.labels_item', { bucket_plural: data.bucketLabelPlural, order_plural: data.orderLabelPlural }),
          ...(inviteCount > 0
            ? [t(inviteCount === 1 ? 'done.invites_item' : 'done.invites_item_plural', { count: inviteCount })]
            : []),
        ].map((item) => (
          <div
            key={item}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-3)',
              padding: 'var(--space-2) 0',
              fontSize: 'var(--text-sm)',
              color: 'var(--color-text)',
            }}
          >
            <CheckCircle size={16} color="var(--color-success)" />
            {item}
          </div>
        ))}
      </div>

      <button
        onClick={onDone}
        style={{
          width: '100%',
          padding: 'var(--space-3) var(--space-5)',
          background: 'var(--color-brand)',
          color: 'var(--color-text-inverse)',
          border: 'none',
          borderRadius: 'var(--radius-md)',
          fontSize: 'var(--text-base)',
          fontWeight: 'var(--font-medium)',
          cursor: 'pointer',
        }}
      >
        {t('done.cta')} →
      </button>
    </div>
  );
}
